var _rect, _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeGlassIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 51,
    viewBox: "0 0 52 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    width: 45,
    height: 45,
    rx: 5,
    fill: "#393184"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_406_157)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    rx: 5,
    transform: "matrix(-1 0 0 1 45 6)",
    fill: "#E2DFFF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.25,
    y: 0.25,
    width: 44.5,
    height: 44.5,
    rx: 4.75,
    transform: "matrix(-1 0 0 1 44.5 6)",
    stroke: "url(#paint0_linear_406_157)",
    strokeWidth: 0.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 24.101C10 25.5585 10.6122 26.5284 11.5398 27.2953C12.6075 28.1779 14.347 28.2983 15.5452 27.5751C15.7933 27.4254 15.9685 27.3044 16.1761 27.1211L16.7065 26.5667L17.5103 27.341C18.8665 28.4477 21.0846 28.2493 22.3657 26.8507C22.4651 26.7422 22.5078 26.6445 22.6241 26.5667C22.7409 26.6449 22.7633 26.7151 22.8589 26.825L23.4278 27.341C24.4694 28.191 26.2248 28.2725 27.3803 27.5751C28.2471 27.0519 28.3552 26.6915 28.5416 26.5667C28.6584 26.6449 28.6808 26.7151 28.7764 26.825C28.8559 26.9162 28.9564 27.0141 29.0464 27.0974C30.1017 28.0743 31.8503 28.3705 33.0995 27.6727C33.6195 27.3822 33.6961 27.3515 34.1514 26.9C34.7921 26.2647 35.2481 25.2704 35.2481 24.101C35.2481 23.7724 34.3812 20.4853 34.2817 20.0869C34.193 19.7321 34.1237 19.4552 34.0351 19.1007C33.8467 18.3468 33.6755 17 32.3387 17H12.9094C11.4321 17 11.3021 18.7446 10.9763 20.0475C10.812 20.7046 10.6458 21.3696 10.4734 22.0594C10.3765 22.4471 10 23.811 10 24.101Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5785 29.1308C11.5785 31.0212 11.5785 32.9115 11.5785 34.8018C11.5785 35.7242 11.5347 36.7548 11.5771 37.6634C11.6116 38.4033 12.3463 39.092 13.0086 39.092H19.4686V32.78H25.7806V39.092H32.2406C32.8951 39.092 33.6139 38.4172 33.6699 37.7105C33.7363 36.8737 33.6706 35.7225 33.6706 34.8511C33.6706 32.9444 33.6706 31.0376 33.6706 29.1308C33.404 29.193 33.1768 29.3604 32.426 29.5135C31.2582 29.7515 30.0893 29.5163 29.0674 29.0001C28.8523 28.8915 28.7407 28.7921 28.5421 28.687C28.3263 28.8012 28.1807 28.9213 27.9515 29.0333C27.7559 29.1289 27.5162 29.2222 27.2893 29.3081C26.0547 29.7755 24.3997 29.6119 23.2152 29.0333C22.986 28.9213 22.8404 28.8012 22.6246 28.687C21.9874 29.0242 22.2518 28.975 21.3718 29.3081C20.4327 29.6636 18.899 29.6636 17.9598 29.3081C17.7329 29.2222 17.4933 29.1289 17.2977 29.0333C17.0685 28.9213 16.9229 28.8012 16.707 28.687C16.5219 28.785 16.3988 28.8885 16.2147 28.9836C16.0234 29.0824 15.8716 29.1665 15.6411 29.2484C15.2639 29.3823 14.7921 29.5509 14.3389 29.5735C13.4217 29.6192 13.0607 29.6119 12.1904 29.3573C11.957 29.289 11.7897 29.18 11.5785 29.1308Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_406_157",
    x: -8,
    y: -2,
    width: 61,
    height: 61,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_406_157"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_406_157",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_406_157",
    x1: 75.5,
    y1: 21.5,
    x2: 40,
    y2: 103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C60F1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeGlassIcon2);
export default __webpack_public_path__ + "static/media/home-glass-icon2.203806048847330e4bd0bf3d209adbd9.svg";
export { ForwardRef as ReactComponent };